import { render, staticRenderFns } from "./simAllOpenPkg.vue?vue&type=template&id=40e2330b&scoped=true&"
import script from "./simAllOpenPkg.vue?vue&type=script&lang=js&"
export * from "./simAllOpenPkg.vue?vue&type=script&lang=js&"
import style0 from "./simAllOpenPkg.vue?vue&type=style&index=0&id=40e2330b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e2330b",
  null
  
)

export default component.exports